export const GUARANTEES_APPLICATION_FILES_BLOCK_TITLE = 'Документи заявки';
export const GUARANTEES_APPLICATION_FILES_LOADING_TEXT = 'Завантаження документів';
export const GUARANTEES_APPLICATION_FILES_EMPTY_FILE_TEXT = 'Файл відсутній';
export const GUARANTEES_APPLICATION_FILES_UPLOAD_LABEL = 'Додати';
export const GUARANTEES_APPLICATION_FILES_REPLACE_LABEL = 'Замінити';
export const GUARANTEES_APPLICATION_FILES_REGENERATE_LABEL = 'Перегенерувати';
export const GUARANTEES_APPLICATION_FILES_DOWNLOAD_LABEL = 'Завантажити';
export const GUARANTEES_APPLICATION_FILES_DELETE_LABEL = 'Видалити';

export const GUARANTEES_APPLICATION_FILE_ERROR_CODES = {
  FILE_ACTION_NOT_ALLOWED: 'FILE_ACTION_NOT_ALLOWED',
  APPLICATION_FILE_ALREADY_EXISTS_USE_FILE_ID: 'APPLICATION_FILE_ALREADY_EXISTS_USE_FILE_ID',
  APPLICATION_FILE_NOT_FOUND: 'APPLICATION_FILE_NOT_FOUND',
  FILE_TYPE_REGENERATION_NOT_SUPPORTED: 'FILE_TYPE_REGENERATION_NOT_SUPPORTED',
} as const;

export const GUARANTEES_APPLICATION_FILE_CAPABILITY_KEYS = [
  'canDownload',
  'canUpload',
  'canRegenerate',
  'canDelete',
] as const;
